import { useQuery } from "@tanstack/react-query";
import { getAuthorized } from "@/lib/fetch";
import { Clients } from "@/lib/clients";
import { Tables } from "@/gen/tableNames/tables";

export function useStrategyCurrency(
  rawStrategyId: string | number | null | undefined,
) {
  const strategyId =
    typeof rawStrategyId === "number" ? rawStrategyId : Number(rawStrategyId);
  const enabled = Number.isFinite(strategyId) && strategyId > 0;

  const { data } = useQuery({
    queryKey: [Clients.M2, Tables.M2_POSITIONS, "strategy-currency", strategyId],
    queryFn: async () => {
      const res = await getAuthorized(
        `${import.meta.env.VITE_BACKEND_URL}/${Clients.M2}/${Tables.M2_POSITIONS}/strategy-currency/${strategyId}`,
      );
      return res.json();
    },
    enabled,
  });

  return enabled ? (data?.currency_text ?? null) : null;
}
